<template>
    <div name="description-of-soldoc1" class="description-of-soldoc1">
        <div class="description-of-soldoc1-inner">
            <h3>우리 병원에 꼭 맞는 환자<br> 맞춤으로 모셔보세요</h3>
            <iframe class="movie" src="https://www.youtube.com/embed/SuhR0J-2BYw?si=oo-JGoKY1jVIY9z0" title="[솔닥] 솔닥이 제공하는 서비스를 소개합니다" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <div class="section-container">
                <div class="item item1">
                    <h4>솔닥</h4>
                    <strong>앱을 통한 대면/비대면진료 병원 예약</strong>
                    <p>단순 감기부터, 만성질환 약 처방까지.<br>과도한 가격 경쟁 없이 의료진과 환자의 시간을 모두 아껴주는<br>대면/비대면 진료 연계 서비스를 제공합니다.</p>
                    <div class="label-area">
                        <span>비대면진료</span>
                        <span>대면진료</span>
                    </div>
                </div>
                <div class="item item2">
                    <h4>바로돌봄</h4>
                    <strong>만 65세 이상 어르신 초진 비대면진료 가능</strong>
                    <p>바로돌봄은 주간보호센터 어르신 분들에게 비대면진료를<br>제공하는 서비스입니다.<br>솔닥과 제휴된 센터와 솔닥 파트너스 의료진을 연결하여<br>병원과 어르신 모두가 편한 비대면진료를 제공합니다.</p>
                    <div class="label-area">
                        <span>비대면진료</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "description-of-soldoc1",
    data: function() {
        return {};
    },
    computed: {},
    mounted: function() {
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".description-of-soldoc1").offset().top;
            var aniTitle = $(".description-of-soldoc1-inner h3");
            var aniItem = $(".description-of-soldoc1-inner .section-container");

            if (height <= 0) {
                $(aniTitle).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            } else if (height > innerTop - 500 && height < innerTop + 1500) {
                $(aniTitle).removeClass('item-hide').addClass('item-show');
                $(aniItem).removeClass('item-hide').addClass('item-show');
            } else if (height > innerTop + 1500) {
                $(aniTitle).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            }
        });
    },
};
</script>

<style scoped>
.description-of-soldoc1 {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    height: 1433px;
    height: auto;
    background: #FFF;
    overflow: hidden;
}
.description-of-soldoc1 .description-of-soldoc1-inner {    
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1240px;
    padding: 166px 20px 130px;
    margin: 0 auto;
}
.description-of-soldoc1-inner h3 {
    min-height: 123px;
    margin-bottom: 0;
    text-align: center;
    font-size: 46px;
    font-weight: 600;
    line-height: 60px;
    color: #000;
    visibility: hidden;
    opacity: 0;
}
.description-of-soldoc1-inner .section-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 160px;
    visibility: hidden;
    opacity: 0;
}
.description-of-soldoc1-inner .item-hide {
    visibility: hidden;
    opacity: 0;
}
.description-of-soldoc1-inner .item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp1 1s;
}
.description-of-soldoc1-inner .section-container .item {
    position: relative;
    width: 100%;
    height: 374px;
}
.description-of-soldoc1-inner .section-container .item + .item {
    margin-top: 147px;
}
.description-of-soldoc1-inner .section-container .item:first-child {
    padding-left: 646px;
}
.description-of-soldoc1-inner .section-container .item:last-child {
    padding-right: 699px;
}
.description-of-soldoc1-inner .section-container .item:first-child::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 601px;
    height: 374px;
    background: url(../../assets/partners_pc/img_description_of_soldoc1.png) 0 0 no-repeat;
    background-size: 601px 374px;
    border-radius: 20px;
    overflow: hidden;
}
.description-of-soldoc1-inner .section-container .item:last-child::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 600px;
    height: 374px;
    background: url(../../assets/partners_pc/img_description_of_soldoc2.png) 0 0 no-repeat;
    background-size: 600px 374px;
    border-radius: 20px;
    overflow: hidden;
}
.description-of-soldoc1-inner .section-container .item h4 {
    margin-bottom: 39px;
    font-size: 38px;
    font-weight: 600;
    line-height: 48px;
    color: #1A1A1A;
}
.description-of-soldoc1-inner .section-container .item strong {
    display: block;
    margin-bottom: 22px;
    font-size: 28px;
    font-weight: 600;
    line-height: 37px; 
    color: #1A1A1A;
}
.description-of-soldoc1-inner .section-container .item p {
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px; 
    color: #1A1A1A;
}
.description-of-soldoc1-inner .section-container .item .label-area {
    display: flex;
    align-items: center;
    height: 40px;
    margin-top: 62px;
}
.description-of-soldoc1-inner .section-container .item .label-area span {
    width: 106px;
    height: 100%;
    padding: 0 15px;
    border-radius: 100px;
    background: #008DEF;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 40px;
    color: #FFF;
}
.description-of-soldoc1-inner .section-container .item .label-area span + span {
    width: 86px;
    margin-left: 6px;
}
.movie {
    margin-top: 70px;
    width: 100%;
    height: 676px;
}

@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pc_partners/DescriptionOfSoldoc1.vue